// import async from '../components/Async'
import * as Icon from 'react-feather'

import GeneralDashboard from '../pages/general/dashboard.tsx'
import TendersList from '../pages/tendering/tenders'
import TenderDetail from '../pages/tendering/tender'
import TenderBidders from '../pages/tendering/bidders'
import Snags from '../pages/snags/index.tsx'
import DocControl from '../pages/doc-control/index.tsx'
import Meetings from '../pages/meetings/index.tsx'
import MeetingDetail from '../pages/meetings/detail.tsx'
import Submittals from '../pages/submittals/index.tsx'
import SubmittalDetail from '../pages/submittals/detail/index.tsx'
import Schedule from '../pages/schedule/index.tsx'
import ScheduleDetail from '../pages/schedule/detail/index.tsx'
import CostControl from '../pages/cost-control/index.tsx'
import Photos from '../pages/photos/index.tsx'
import ChangeDetail from '../pages/cost-control/changes/ChangeDetail.tsx'
import ContractDetail from '../pages/cost-control/contracts/ContractDetail.tsx'
import InvoiceDetail from '../pages/cost-control/invoices/InvoiceDetail.tsx'
import ApplicationDetail from '../pages/cost-control/applications/ApplicationDetail.tsx'
import RfqDetail from '../pages/cost-control/rfq/RfqDetail.tsx'
import Bidders from '../pages/tendering/bidder/index.tsx'
import ProjectSetup from '../pages/project-info'
import OrganizationSettings from '../pages/organization/settings'
import Subscription from '../pages/payment/subscription'
import Account from '../pages/account'

import TestPage from '../pages/test'
import TreeTest from '../pages/tree'

// // Landing
// import Landing from '../pages/landing/Landing'

// Auth
import SignIn from '../pages/auth/SignIn.tsx'
import SignUp from '../pages/auth/SignUp'
import SignUpFinish from '../pages/auth/SignUpFinish'
import SignOut from '../pages/auth/SignOut'
import ResetPassword from '../pages/auth/ResetPassword'
import ResetPasswordFinish from '../pages/auth/ResetPasswordFinish'
import SharedLinkPage from '../pages/shared/SharedLinkPage'
import SharedPhotosPage from '../pages/shared/SharedPhotosPage'
import TransmittalAccessPage from '../pages/shared/TransmittalAccessPage'
// import Page404 from '../pages/auth/Page404'
// import Page500 from '../pages/auth/Page500'

const generalRoutes = {
  path: '/dashboard/',
  name: 'Route_dashboard',
  header: null,
  icon: Icon.BarChart,
  hidden: false,
  component: GeneralDashboard,
  allowedRoles: ['OWNER', 'ADMIN', 'USER'],
}

const tenderingRoutes = {
  path: '/project/',
  name: 'Route_procurement',
  module: 'PROCUREMENT',
  header: null,
  icon: Icon.Award,
  containsHome: true,
  allowedRoles: ['OWNER', 'ADMIN', 'USER'],
  children: [
    {
      path: '/project/:projectId/tendering/tenders',
      name: 'Route_procurement_tenders',
      component: TendersList,
      module: 'PROCUREMENT',
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
    {
      path: '/project/:projectId/tendering/tenders/:id',
      name: 'Route_procurement_tender_detail',
      component: TenderDetail,
      module: 'PROCUREMENT',
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
    {
      path: '/project/:projectId/tendering/bidders',
      name: 'Route_procurement_bidders',
      component: TenderBidders,
      module: 'PROCUREMENT',
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
    // {
    //   path: '/test',
    //   name: 'Test',
    //   component: TestPage,
    //   allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    // },
    // {
    //   path: '/tree',
    //   name: 'TreeTest',
    //   component: TreeTest,
    //   allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    // },
  ],
}

const biddersRoutes = {
  path: '/bidder',
  name: 'Route_bidder',
  component: Bidders,
  hidden: true,
}

const projectRoutes = {
  path: '/project-setup/:projectId',
  name: 'Route_project',
  header: null,
  icon: Icon.Briefcase,
  hidden: false,
  component: ProjectSetup,
  // Project settings are a management surface: only roles with PROJECT.EDIT
  // (project managers; org admins via the management-module union) see them.
  // The snags child below keeps its own ISSUES gate — restricted roles keep
  // snags while losing the settings landing page.
  module: 'PROJECT',
  moduleAction: 'EDIT',
  allowedRoles: ['OWNER', 'ADMIN', 'USER'],
  children: [
    {
      path: '/project-setup/:projectId/snags',
      name: 'Route_project_snags',
      component: Snags,
      module: 'ISSUES',
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
    // Freelo #33206294: Photos sit under Construction next to snags; the URL stays /project/…/photos.
    {
      path: '/project/:projectId/photos',
      name: 'Route_photos',
      component: Photos,
      module: 'PHOTOS',
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
  ],
}

const docControlRoutes = {
  path: '/project/:projectId/documents',
  name: 'Route_documents',
  module: 'DOC_CONTROL',
  header: null,
  icon: Icon.Folder,
  hidden: false,
  component: DocControl,
  allowedRoles: ['OWNER', 'ADMIN', 'USER'],
}

const meetingsRoutes = {
  path: '/project/:projectId/meetings',
  name: 'Route_meetings',
  module: 'MEETINGS',
  header: null,
  icon: Icon.Calendar,
  hidden: false,
  component: Meetings,
  allowedRoles: ['OWNER', 'ADMIN', 'USER'],
  children: [
    {
      path: '/project/:projectId/meetings/:id',
      name: 'Route_meeting_detail',
      component: MeetingDetail,
      module: 'MEETINGS',
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
  ],
}

const submittalsRoutes = {
  path: '/project/:projectId/submittals',
  name: 'Route_submittals',
  module: 'SUBMITTALS',
  header: null,
  icon: Icon.CheckSquare,
  hidden: false,
  component: Submittals,
  allowedRoles: ['OWNER', 'ADMIN', 'USER'],
  children: [
    {
      path: '/project/:projectId/submittals/:submittalId',
      name: 'Route_submittal_detail',
      component: SubmittalDetail,
      module: 'SUBMITTALS',
      // Query.submittal's registry policy deliberately grants a named reviewer
      // access even without module rights (e.g. an EXTERNAL subcontractor asked
      // to review one specific item) — the client-side module gate can't express
      // that OR, so the backend is the real gate here. The page's own error
      // state (SubmittalDetail's `error` branch) renders on denial.
      guardPolicy: 'server',
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
  ],
}

const scheduleRoutes = {
  path: '/project/:projectId/schedule',
  name: 'Route_schedule',
  module: 'SCHEDULE',
  header: null,
  icon: Icon.AlignLeft,
  hidden: false,
  component: Schedule,
  allowedRoles: ['OWNER', 'ADMIN', 'USER'],
  children: [
    {
      path: '/project/:projectId/schedule/:scheduleId',
      name: 'Route_schedule_detail',
      component: ScheduleDetail,
      module: 'SCHEDULE',
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
  ],
}

const costControlRoutes = {
  path: '/project/:projectId/cost-control',
  name: 'Route_cost_control',
  module: 'COST_CONTROL',
  header: null,
  icon: Icon.PieChart,
  hidden: false,
  component: CostControl,
  allowedRoles: ['OWNER', 'ADMIN', 'USER'],
  children: [
    {
      path: '/project/:projectId/cost-control/contracts/:contractId',
      name: 'Route_cost_control_contract',
      component: ContractDetail,
      module: 'COST_CONTROL',
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
    {
      path: '/project/:projectId/cost-control/changes/:changeId',
      name: 'Route_cost_control_change',
      component: ChangeDetail,
      module: 'COST_CONTROL',
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
    {
      path: '/project/:projectId/cost-control/invoices/:invoiceId',
      name: 'Route_cost_control_invoice',
      component: InvoiceDetail,
      module: 'COST_CONTROL',
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
    {
      path: '/project/:projectId/cost-control/applications/:applicationId',
      name: 'Route_cost_control_application',
      component: ApplicationDetail,
      module: 'COST_CONTROL',
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
    {
      path: '/project/:projectId/cost-control/rfqs/:rfqId',
      name: 'Route_cost_control_rfq',
      component: RfqDetail,
      module: 'COST_CONTROL',
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN', 'USER'],
    },
  ],
}

const organizationRoutes = {
  path: '/organization',
  icon: Icon.Globe,
  exact: true,
  name: 'Route_organization',
  header: null,
  hidden: false,
  containsHome: true,
  component: OrganizationSettings,
  children: [
    {
      name: 'Route_organization_project',
      path: '/organization/projects/:projectId',
      component: ProjectSetup,
      hidden: true,
      allowedRoles: ['OWNER', 'ADMIN'],
    },
  ],
  allowedRoles: ['OWNER', 'ADMIN'],
}

const authRoutes = {
  path: '/auth',
  name: 'Route_auth',
  header: null,
  icon: Icon.Users,
  containsHome: true,
  hidden: true,
  children: [
    { path: '/auth/signin', name: 'Route_auth_sign_in', component: SignIn },
    { path: '/auth/signup', name: 'Route_auth_sign_up', component: SignUp },
    { path: '/auth/signupfinish', name: 'Route_auth_sign_up_finish', component: SignUpFinish },
    { path: '/auth/signout', name: 'Route_auth_sign_ou', component: SignOut },
    { path: '/auth/reset', name: 'Route_auth_reset', component: ResetPassword },
    {
      path: '/auth/resetpasswordfinish',
      name: 'Route_auth_reset_password_finish',
      component: ResetPasswordFinish,
    },
  ],
}

const paymentRoutes = {
  path: '/payment/subscriptions',
  name: 'Route_payment', // TODO - add translations
  header: null,
  hidden: true,
  icon: Icon.CreditCard,
  component: Subscription,
}

const accountRoutes = {
  path: '/account',
  name: 'Route_account',
  header: null,
  hidden: true,
  icon: Icon.User,
  component: Account,
}

const sharedRoutes = {
  path: '/shared/:token',
  name: 'Route_shared',
  hidden: true,
  component: SharedLinkPage,
}

const transmittalRoutes = {
  path: '/transmittal/:token',
  name: 'Route_transmittal',
  hidden: true,
  component: TransmittalAccessPage,
}

const photoShareRoutes = {
  path: '/share/photos/:token',
  name: 'Route_photo_share',
  hidden: true,
  component: SharedPhotosPage,
}

export const tendering = [tenderingRoutes]
export const bidders = [biddersRoutes]
export const auth = [authRoutes]
export const organization = [organizationRoutes]
export const general = [generalRoutes]
export const project = [projectRoutes]
export const documents = [docControlRoutes]
export const meetings = [meetingsRoutes]
export const submittals = [submittalsRoutes]
export const schedule = [scheduleRoutes]
export const costControl = [costControlRoutes]
export const payment = [paymentRoutes]
export const account = [accountRoutes]
export const shared = [sharedRoutes, transmittalRoutes, photoShareRoutes]

// All routes
export default [
  generalRoutes,
  tenderingRoutes,
  docControlRoutes,
  meetingsRoutes,
  submittalsRoutes,
  scheduleRoutes,
  costControlRoutes,
  projectRoutes,
  organizationRoutes,
  biddersRoutes,
  authRoutes,
  paymentRoutes,
  accountRoutes,
]
